import React, { forwardRef, useState } from 'react';
import { Input } from './ui/input';
import { Eye, EyeOff } from 'lucide-react';

/**
 * PasswordInput - wraps the Shadcn Input with a show/hide toggle.
 * Accepts every prop Input accepts. Forces type based on internal visibility.
 */
const PasswordInput = forwardRef(({ className = '', dir, ...props }, ref) => {
  const [visible, setVisible] = useState(false);
  // Ensure right-side padding for the icon regardless of caller's ps-* classes
  const paddedClass = `${className} pe-10`;
  return (
    <div className="relative">
      <Input
        ref={ref}
        {...props}
        type={visible ? 'text' : 'password'}
        className={paddedClass}
        dir={dir}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        data-testid="toggle-password-visibility"
        aria-label={visible ? 'Hide password' : 'Show password'}
        tabIndex={-1}
        className="absolute top-1/2 -translate-y-1/2 end-3 text-[#2563eb]/70 hover:text-[#3b82f6] transition-colors"
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});

PasswordInput.displayName = 'PasswordInput';
export default PasswordInput;
